import { defineComponent } from 'vue';
import { useAppStore } from 'src/apps/cloud/stores/app.ts';
import { useDBStore } from 'src/apps/cloud/stores/db';
import { useDialogStore } from 'src/apps/cloud/stores/dialog.ts';
import { useFarmStore } from 'src/apps/cloud/stores/farm.ts';
import WSClass from 'src/apps/cloud/utils/classes/WS.class';
import UserClass from 'src/apps/cloud/utils/classes/User.class.ts';
import FarmClass from 'src/apps/cloud/utils/classes/Farm.class.ts';
import ServerClass from 'src/apps/cloud/utils/classes/Server.class.ts';
import DeviceClass from 'src/apps/cloud/utils/classes/Device.class.ts';
import CommandClass from 'src/apps/cloud/utils/classes/Command.class.ts';
import DialogComponent from 'src/apps/cloud/versions/v1/components/DialogComponent.vue';
export default defineComponent({
    name: 'AppCloud',
    components: {
        DialogComponent
    },
    setup() {
    },
    async beforeMount() {
        /** Тема */
        this.$q.dark.set(true);
        /** Хранилища состояний */
        this.$q.store = {
            app: useAppStore(),
            db: useDBStore(),
            dialog: useDialogStore(),
            farm: useFarmStore()
        };
        /** Классы */
        this.$q.class = {
            WS: new WSClass(),
            User: new UserClass(),
            Farm: new FarmClass(),
            Server: new ServerClass(),
            Device: new DeviceClass(),
            Command: new CommandClass()
        };
        /** Авторизация */
        let telegramAuthSuccess = false;
        const tg = window.Telegram?.WebApp;
        this.$q.store.app.tgInitData = tg?.initData || null;
        this.$q.store.app.is_tgApp = this.$q.store.app.tgInitData !== null;
        if (tg && tg.initData) {
            tg.ready();
            const connection = await this.$q.class.WS.connect();
            if (connection) {
                try {
                    telegramAuthSuccess = await this.$q.class.User.loginWithTelegram(tg.initData);
                }
                catch (e) {
                    console.error('Telegram login failed', e);
                }
            }
        }
        if (!telegramAuthSuccess) {
            const token = sessionStorage.getItem('token');
            // Если нет токена в sessionStorage, то пропускаем подключение и авторизацию
            if (!token) {
                sessionStorage.removeItem('token');
                this.$q.store.app.user = null;
            }
            // Если есть токен в localstorage, то соединяемся с WS и пробуем авторизоваться
            else {
                const connection = await this.$q.class.WS.connect();
                if (connection) {
                    try {
                        await this.$q.class.User.loginWithToken(token);
                    }
                    catch (e) {
                    }
                }
            }
        }
        /** Убираем стартовый загрузочный экран */
        const splashScreen = document.querySelector('.splash-screen');
        if (splashScreen) {
            splashScreen.classList.add('hide');
            setTimeout(() => {
                splashScreen.remove();
            }, 1000);
        }
        /** Приложение готово к рендеру */
        this.$q.store.app.ready = true;
    }
});
